const APIs = {
  LEDGER_LIST: 'admin/ledgers',
  LEDGER_ITEMS_LIST: 'admin/ledgers/:id/ledger-items',
  SINGLE_LEDGER: 'admin/ledgers/:id',
  SINGLE_LEDGER_ITEM: 'admin/ledgers/:ledgerId/ledger-items/:ledgerItemId',
  RETRY_SETTLEMENT: 'admin/ledgers/:id/retry',
}

export default APIs
